<template>
    <div id="limit-alert-form-component">
        <v-radio-group v-model="configuration.operator" class="mt-1">
            <v-radio value=">">
                <template v-slot:label>
                    <span class="font-14">{{ $t('dialog_update_alert_component.superior') }}</span>
                </template>
            </v-radio>

            <v-radio value="<">
                <template v-slot:label>
                    <span class="font-14">{{ $t('dialog_update_alert_component.inferior') }}</span>
                </template>
            </v-radio>

            <v-radio value="=">
                <template v-slot:label>
                    <span class="font-14">{{ $t('dialog_update_alert_component.equal') }}</span>
                </template>
            </v-radio>
        </v-radio-group>

        <v-text-field
            v-model="configuration.limit"
            :label="$t('dialog_update_alert_component.value')"
            filled
            type="number"
        />
    </div>
</template>

<script>
export default {
    name: 'LimitAlertFormComponent',
    props: {
        configuration: {
            type: Object,
            required: true,
        },
    },
}
</script>
